import { searchArrayOfStrings } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import { memo, useEffect, useState } from 'react';
import type { ViewMoreProps as Props } from './types';

export const ViewMore = memo(
  ({
    list,
    items,
    limit,
    displayTags,
    buttonSx,
    buttonProps,
    listWrapperSx,
    search,
  }: Props) => {
    displayTags = displayTags ?? limit;
    const [showFull, setShowFull] = useState(false);

    useEffect(() => {
      if (search) {
        const searchedItems = searchArrayOfStrings(items, search);
        const hasResultSearch = searchedItems?.some((i) => i);
        if (hasResultSearch) setShowFull(!showFull);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const toggleText: React.MouseEventHandler<HTMLButtonElement> = (e) => {
      e.stopPropagation();
      setShowFull(!showFull);
    };

    const displayList = showFull
      ? list
      : list?.slice(0, list.length > limit ? displayTags : limit);

    return (
      <>
        <Box
          display={'flex'}
          flexWrap={'wrap'}
          alignItems={'center'}
          width={'100%'}
          gap={0.5}
          sx={listWrapperSx}
        >
          {displayList}
        </Box>

        {list && list.length > limit && (
          <Box>
            <Button
              variant="outlined"
              color="primary"
              {...buttonProps}
              sx={buttonSx}
              onClick={toggleText}
            >
              {showFull
                ? 'View Less'
                : `+${list.length - displayTags} See More`}
            </Button>
          </Box>
        )}
      </>
    );
  }
);
